/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as IndexRouteImport } from './../../pages/index'
import { Route as AppRouteImport } from './../../pages/_app'
import { Route as LoginRouteImport } from './../../pages/login'
import { Route as AppClientsRouteImport } from './../../pages/_app.clients'
import { Route as AppScheduleRouteImport } from './../../pages/_app.schedule'
import { Route as AppSettingsRouteImport } from './../../pages/_app.settings'
import { Route as AppTasksRouteImport } from './../../pages/_app.tasks'
import { Route as AppTeamRouteImport } from './../../pages/_app.team'
import { Route as BExcursionIdRouteImport } from './../../pages/b.$excursionId'
import { Route as AppExcursionsIndexRouteImport } from './../../pages/_app.excursions.index'
import { Route as AppExcursionsExcursionIdRouteImport } from './../../pages/_app.excursions.$excursionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleRoute = AppScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const BExcursionIdRoute = BExcursionIdRouteImport.update({
  id: '/b/$excursionId',
  path: '/b/$excursionId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppExcursionsIndexRoute = AppExcursionsIndexRouteImport.update({
  id: '/excursions/',
  path: '/excursions/',
  getParentRoute: () => AppRoute,
} as any)
const AppExcursionsExcursionIdRoute =
  AppExcursionsExcursionIdRouteImport.update({
    id: '/excursions/$excursionId',
    path: '/excursions/$excursionId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/clients': typeof AppClientsRoute
  '/schedule': typeof AppScheduleRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/b/$excursionId': typeof BExcursionIdRoute
  '/excursions/$excursionId': typeof AppExcursionsExcursionIdRoute
  '/excursions/': typeof AppExcursionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/clients': typeof AppClientsRoute
  '/schedule': typeof AppScheduleRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/b/$excursionId': typeof BExcursionIdRoute
  '/excursions/$excursionId': typeof AppExcursionsExcursionIdRoute
  '/excursions': typeof AppExcursionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/clients': typeof AppClientsRoute
  '/_app/schedule': typeof AppScheduleRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/team': typeof AppTeamRoute
  '/b/$excursionId': typeof BExcursionIdRoute
  '/_app/excursions/$excursionId': typeof AppExcursionsExcursionIdRoute
  '/_app/excursions/': typeof AppExcursionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/clients'
    | '/schedule'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/b/$excursionId'
    | '/excursions/$excursionId'
    | '/excursions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/clients'
    | '/schedule'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/b/$excursionId'
    | '/excursions/$excursionId'
    | '/excursions'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/clients'
    | '/_app/schedule'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/team'
    | '/b/$excursionId'
    | '/_app/excursions/$excursionId'
    | '/_app/excursions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  BExcursionIdRoute: typeof BExcursionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule': {
      id: '/_app/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AppScheduleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/b/$excursionId': {
      id: '/b/$excursionId'
      path: '/b/$excursionId'
      fullPath: '/b/$excursionId'
      preLoaderRoute: typeof BExcursionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/excursions/': {
      id: '/_app/excursions/'
      path: '/excursions'
      fullPath: '/excursions/'
      preLoaderRoute: typeof AppExcursionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/excursions/$excursionId': {
      id: '/_app/excursions/$excursionId'
      path: '/excursions/$excursionId'
      fullPath: '/excursions/$excursionId'
      preLoaderRoute: typeof AppExcursionsExcursionIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppClientsRoute: typeof AppClientsRoute
  AppScheduleRoute: typeof AppScheduleRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppTeamRoute: typeof AppTeamRoute
  AppExcursionsExcursionIdRoute: typeof AppExcursionsExcursionIdRoute
  AppExcursionsIndexRoute: typeof AppExcursionsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppClientsRoute: AppClientsRoute,
  AppScheduleRoute: AppScheduleRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTasksRoute: AppTasksRoute,
  AppTeamRoute: AppTeamRoute,
  AppExcursionsExcursionIdRoute: AppExcursionsExcursionIdRoute,
  AppExcursionsIndexRoute: AppExcursionsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  BExcursionIdRoute: BExcursionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
